'use client'

import { usePathname } from 'next/navigation'
import { Footer } from '@/sections/Footer'

export function ConditionalFooter() {
  const pathname = usePathname()

  if (pathname.startsWith('/driving-schools')) {
    return null
  }

  return <Footer />
}
